/**
 * 4/4/9 macro consistency — mirrors backend services/macro_calculator.py
 * (compute_calories_from_macros / validate_macros_4_4_9), the source of truth
 * PUT /profile/macros now enforces. Manual mode never changes the user's
 * grams: the calorie total is DERIVED from them.
 */
export function caloriesFromMacros(protein, carbs, fat) {
  return (protein * 4) + (carbs * 4) + (fat * 9);
}

function toInt(v) {
  if (v === '' || v === null || v === undefined) return null;
  var n = parseInt(v, 10);
  return Number.isFinite(n) ? n : null;
}

/**
 * Inspect the four manual fields (strings or numbers).
 *   complete         all four parse as integers
 *   expectedCalories P*4 + C*4 + F*9 once P/C/F are all entered (else null)
 *   consistent       complete AND calories === expectedCalories
 *   mismatch         complete AND calories !== expectedCalories
 */
export function checkManualMacros(values) {
  var calories = toInt(values && values.calories);
  var protein = toInt(values && values.protein);
  var carbs = toInt(values && values.carbs);
  var fat = toInt(values && values.fat);
  var gramsComplete = protein !== null && carbs !== null && fat !== null;
  var expectedCalories = gramsComplete ? caloriesFromMacros(protein, carbs, fat) : null;
  var complete = gramsComplete && calories !== null;
  return {
    calories: calories, protein: protein, carbs: carbs, fat: fat,
    complete: complete,
    expectedCalories: expectedCalories,
    consistent: complete && calories === expectedCalories,
    mismatch: complete && calories !== expectedCalories,
  };
}
